
import Cookies from 'universal-cookie';

const cookies = new Cookies();


// new one 
const defaultOptions = {
  path: '/',
  secure: false,          
  sameSite: 'lax',       
  maxAge: 60 * 60 * 24 * 30 
};


// إدارة التوكنز
export const tokenManager = {
  // تخزين access token
  setAccessToken: (token) => {
    cookies.set('access_token', token, defaultOptions);
  },

  // تخزين refresh token
  setRefreshToken: (token) => {
    cookies.set('refresh_token', token, defaultOptions);
  },

  // الحصول على access token
  getAccessToken: () => {
    return cookies.get('access_token');
  },

  // الحصول على refresh token
  getRefreshToken: () => {
    return cookies.get('refresh_token');
  },

  // تحديث التوكنز
  updateTokens: (access, refresh) => {
    cookies.set('access_token', access, defaultOptions);
    cookies.set('refresh_token', refresh, defaultOptions);
  },

  // حذف التوكنز
  removeTokens: () => {
    cookies.remove('access_token', { path: '/' });
    cookies.remove('refresh_token', { path: '/' });
  }
};

// دوال مساعدة للتشفير مع دعم الأحرف العربية
const encodeBase64 = (str) => {
  try {
    // تحويل النص إلى UTF-8 ثم إلى Base64
    return btoa(unescape(encodeURIComponent(str)));
  } catch (e) {
    console.error('Error encoding to Base64:', e);
    return null;
  }
};

const decodeBase64 = (str) => {
  try {
    // فك التشفير من Base64 ثم تحويل من UTF-8
    return decodeURIComponent(escape(atob(str)));
  } catch (e) {
    console.error('Error decoding from Base64:', e);
    return null;
  }
};

// إدارة بيانات المستخدم مع تشفير Base64
export const userDataManager = {
  // تخزين بيانات المستخدم
  setUserData: (userData) => {
    const userInfo = {
      id: userData.id,
      first_name: userData.first_name,
      last_name: userData.last_name,
      role: userData.role
    };
    // تشفير Base64 مع دعم الأحرف العربية
    const encoded = encodeBase64(JSON.stringify(userInfo));
    if (encoded) {
      cookies.set('user_data', encoded, defaultOptions);
    }
  },

  // الحصول على بيانات المستخدم
  getUserData: () => {
    const encoded = cookies.get('user_data');
    if (!encoded) return null;
    try {
      // فك التشفير Base64 مع دعم الأحرف العربية
      const decoded = decodeBase64(encoded);
      return decoded ? JSON.parse(decoded) : null;
    } catch (e) {
      console.error('Error parsing user data:', e);
      return null;
    }
  },

  // حذف بيانات المستخدم
  removeUserData: () => {
    cookies.remove('user_data', { path: '/' });
  }
};

// إدارة الجلسة الكاملة
export const sessionManager = {
  // حفظ جلسة كاملة
  saveSession: (response) => {
    const access = response.access || response.accessToken;
    const refresh = response.refresh || response.refreshToken;
    const userData = response.user || response.userData;

    tokenManager.setAccessToken(access);
    tokenManager.setRefreshToken(refresh);
    userDataManager.setUserData(userData);
  },


  // التحقق من وجود جلسة
  hasSession: () => {
    const accessToken = tokenManager.getAccessToken();
    const refreshToken = tokenManager.getRefreshToken();
    const userData = userDataManager.getUserData();
    return !!(accessToken && refreshToken && userData);
  },

  // حذف الجلسة كاملة
  clearSession: () => {
    tokenManager.removeTokens();
    userDataManager.removeUserData();
  },

  // استعادة الجلسة
  restoreSession: () => {
    const accessToken = tokenManager.getAccessToken();
    const refreshToken = tokenManager.getRefreshToken();
    const userData = userDataManager.getUserData();

    if (accessToken && refreshToken && userData) {
      return {
        accessToken,
        refreshToken,
        userData
      };
    }
    return null;
  }
};

export default cookies; 
